import { graphql } from "relay-runtime"

export const chPrescriptionFragment = graphql`
  fragment chPrescriptionFragment on ch_Prescription {
    id
    createdAt
    createdBy
    fileId
    healthcareProviderId
    language
    medications {
      id
    }
    patientId
    progressNoteId
    signedAt
    signedBy
    updatedAt
    updatedBy
    sentAt
    sentBy
    concludedAt
    concludedBy
    fileMetadata {
      documentType
      extension
      lengthInKilobytes
    }
  }
`
